<template>
	<nk-page commercialAccess="System" :policyClaims="['Accounting_FloatingCenters_Selector']">
		<template #badges>
			<hr />
		</template>
		<ag-grid :options="tableOptions" :data="filteredItems" v-model="selectedItem" @update:modelValue="selectedDataChanged" @preSelectedRowData="(rowData) => selectedItem = rowData" tabindex="101" ref="table" startup class="h-100 "></ag-grid>

	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import { mapGetters } from 'vuex'
	import $sc from '~/plugins/shortcut.collection.js'
	import textVisualizer from '@nikan/text-visualizer'
	import Endpoints from '@nikan/endpoints'

	const FILTERS = {
		ALL: 'all',
		LEAVES: 'leaves',
		CUSTOM: 'custom',
	}

	export default {
		name: 'center-selector',
		modal: {
			size: 'md',
			stateUID: 'floating-center-selector',
			helpTag: 'FloatingCenterList'
		},
		props: {
			data: {},
			options: {},
		},
		data() {
			return {
				filteredItems: [],
				settings: {
					filterType: 'all',
					filterByGroup: [],
					selected: null,
					multiSelection: false,
				},
				selectedItem: null,
				tableOptions: {},
				selectCenterButton: {
					title: this.$t('select'),
					shortcut: $sc.find('enter-only'),
					element: () => this.$refs.table.$el,
					icon: 'check',
					isPrimary: true,
					handle: (button, page, e) => {
						if (_.isEmpty(this.selectedItem))
							return this.$toast(this.$t('document.m.select-row'))

						this.resolve(this.selectedItem)
					},
					policyClaims: 'Accounting_FloatingCenters_Selector',
				},
			}
		},
		computed: {
			...mapGetters({
				center_leaves: 'floatingCenters/leaves',
				center_all: 'floatingCenters/all',
				checkFloatingBalanceAccess: 'appContext/checkAccessFloatingCentersBalanceObserve',
			}),
			computedFilteredItems() {

			},
		},
		created() {
			this.settings = _.extend({}, this.settings, this.options)

			this.prepareTableOption()

			this.filteredItems = this.calcFilterItems()
			this.selectedItem = this.settings.selected

		},
		mounted() {
			this.prepareWindow(this.$t('center.selector.title'), [
				this.selectCenterButton,
			])

		},
		methods: {
			prepareTableOption() {
				const tableOptions = {
					id: this.$options.name,
					focusAndSelect: {
						allowFocus: true
					},
					rowSelection: {
						mode: this.settings.multiSelection ? 'multiRow' : 'singleRow',
						checkboxes: this.settings.multiSelection,
						headerCheckbox: this.settings.multiSelection
					},
					rowModelType: this.settings.serverSideStatus ? 'serverSide' : 'clientSide',
					cellSelectionAggReport: false,
					sideBar: 'none',
					enterToSelect: true,
					doubleClickedToSelect: true,
					pagination: false,
					fitToWidth: false,
					serverInfo: {
						api: {
							url: Endpoints.getUrl('floatingCenters.pageList'),
							manipulateResponse: (res) => {
								return {
									rowData: res.data.items,
									rowCount: res.data.totalCount
								}
							}
						},
						finally: () => {
						},
						payload: {
							baseAccountIds: this.settings.baseAccountIds,
							centerLevel: this.settings.centerLevel ? this.settings.centerLevel : null,
							leaf: true,
							excludeCenterIds: this.settings.excludeCenterIds,
							groups: this.settings.groups,
							includeRelatedAccount: this.settings.includeRelatedAccount
						},
						// pageNumber:this.settings.pageNumber
					},
					columnDefs: [

						{
							field: 'rowNumber',
							headerName: '...',
							width: 50,
							pinned: 'right',
						},
						{
							field: 'accountingCode',
							headerName: this.$t('center.selector.table.c.accountingCode'),
							width: 150,
							contentType: 'string'
						},
						{
							field: 'name',
							headerName: this.$t('center.selector.table.c.name'),
							width: 200,
							contentType: 'string'
						},
						{
							field: 'parent',
							headerName: this.$t('center.selector.table.c.parent'),
							contentType: 'enum',
							valueFormatter: data => {
								return data.value?.name ? data.value.name : null
							},
						},
						{
							field: 'center_NationalCode',
							headerName: this.$t('center.selector.table.c.nc-code'),
							contentType: 'enum',
							filterModel: 'metaData',
							valueFormatter: (params) => {
								const foundField = params.data.metaDatas.find(x => x.metaDataSchema.systemField === 'Center_NationalCode')
								return foundField ? foundField.value : null
							}
						},
						{
							field: 'center_Mobile',
							headerName: this.$t('center.selector.table.c.mobile'),
							contentType: 'enum',
							filterModel: 'metaData',
							valueFormatter: (params) => {
								const foundField = params.data.metaDatas.find(x => x.metaDataSchema.systemField === 'Center_Mobile')
								return foundField ? foundField.value : null
							}
						},

						{
							field: 'center_Phone',
							headerName: this.$t('center.selector.table.c.phone'),
							contentType: 'enum',
							filterModel: 'metaData',

							valueFormatter: (params) => {
								const foundField = params.data.metaDatas.find(x => x.metaDataSchema.systemField === 'Center_Phone')
								return foundField ? foundField.value : null
							}
						},
						{
							field: 'center_Address',
							headerName: this.$t('center.selector.table.c.address'),
							contentType: 'enum',
							filterModel: 'metaData',
							valueFormatter: (params) => {
								const foundField = params.data.metaDatas.find(x => x.metaDataSchema.systemField === 'Center_Address')
								return foundField ? foundField.value : null
							}
						},
						{
							field: 'center_ManagerName',
							headerName: this.$t('center.selector.table.c.managerName'),
							contentType: 'enum',
							filterModel: 'metaData',
							valueFormatter: (params) => {
								const foundField = params.data.metaDatas.find(x => x.metaDataSchema.systemField === 'Center_ManagerName')
								return foundField ? foundField.value : null
							}
						}
					],
				}

				if (this.checkFloatingBalanceAccess) {
					tableOptions.columnDefs.push({
						field: 'balance',
						headerName: this.$t('center.selector.table.c.balance'),
						contentType: 'enum',
						cellRenderer: (params) => {
							if (params.data.balanceRestricted)
								return '***'
							return `<div class="text-info">${textVisualizer(params.data.balance || '', { type: 'balance', })}</div>`
						}
					})
				}

				this.tableOptions = tableOptions
			},
			calcFilterItems() {
				switch (this.settings.filterType) {

					case FILTERS.LEAVES:
						return this.filterByGroupIfPossible(this.center_leaves)

					case FILTERS.CUSTOM:
						return this.data

					case FILTERS.ALL:
					default:
						return this.filterByGroupIfPossible(this.center_all)
				}
			},
			filterByGroupIfPossible(centers) {
				if (!this.settings.filterByGroup.length)
					return centers

				return centers.filter(x => this.settings.filterByGroup.includes(x.group))
			},
			rowDbClicked(val) {
				if (this.grandParentType() === 'modal')
					this.resolve(val)
			},
			selectedDataChanged(val) {
				// rowDbClicked(val) {
				if (this.grandParentType() === 'modal' && !this.settings.multiSelection)
					this.resolve(val)
			}
		},
	}
</script>
<style>
	.center-select {
		overflow: hidden;
		flex: 1;
	}
</style>
